import { getConfig } from '../helpers/config';

export enum TwilioEndpoints {
  verify = 'Verifications',
  check = 'VerificationCheck'
}

export const twilioFetch = async (
  endpoint: TwilioEndpoints,
  data: Record<string, string>
) => {
  const reqHeaders = new Headers();
  const formData = new FormData();

  const config = getConfig();
  const TWILIO_API_URL = config.twilioApiUrl;
  const TWILIO_ACCOUNT_SID = config.twilioAccountSid;
  const TWILIO_AUTH_TOKEN = config.twilioAuthToken;
  const TWILIO_VERIFY_SERVICE_ID = config.twilioVerifyServiceId;

  // set headers
  reqHeaders.append(
    'Authorization',
    /* eslint-disable-next-line prefer-template */
    `Basic ${btoa(TWILIO_ACCOUNT_SID + ':' + TWILIO_AUTH_TOKEN)}`
  );

  // set formData
  Object.keys(data).forEach((k) => {
    formData.append(k, data[k]);
  });

  const res = await fetch(
    `${TWILIO_API_URL}${TWILIO_VERIFY_SERVICE_ID}/${endpoint}`,
    {
      method: 'POST',
      headers: reqHeaders,
      body: formData,
      redirect: 'follow'
    }
  );

  if (res.status < 200 || res.status > 300) {
    const json = await res.json();
    throw new Error(`${json.status}: ${json.message}`);
  } else {
    const json = await res.json();
    return json;
  }
};
